/** @format */

import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { useNavigate } from 'react-router';
import { Link, useLocation, useParams } from 'react-router-dom';

import Logo from '../../Assets/Images/logo.png';
import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import useQuery from '../../Shared/queryString';
import Master from '../Layouts/Master';

const Events = () => {
  const { category } = useParams();
  const { search } = useLocation();
  const title = useQuery.getParam('title');
  const province = useQuery.getParam('province');
  const gender = useQuery.getParam('gender');
  const navigate = useNavigate();
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);
  const [searchInputs, setSearchInputs] = useState({
    title: title != null ? title : '',
    province: province != null ? province : '',
    gender: gender != null ? gender : '',
  });

  useEffect(() => {
    const getInfo = async () => {
      setLoading(true);
      await useApi.get(
        `/category/${category}/event${search}`,
        {},
        (res) => {
          eventContext.events = res.data;
        },
        (err) => {
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
          setLoading(false);
        },
      );
      await useApi.get(
        '/province',
        {},
        (res) => {
          let provinces = [...res.data.data];
          let last = provinces?.pop();
          provinces?.unshift(last);
          eventContext.provinces = provinces;
          setLoading(false);
        },
        (err) => {
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
          setLoading(false);
        },
      );
    };
    getInfo();
  }, [search, category]);

  const onChangeInput = (fieldName, value) => {
    const searchFields = { ...searchInputs };
    searchFields[fieldName] = value;
    setSearchInputs(searchFields);
  };

  const searchEvents = () => {
    let search = '?';

    search += `${
      searchInputs['title'].length > 0 ? 'title=' + searchInputs['title'] : ''
    }`;
    search += `${
      searchInputs['province'].length > 0
        ? '&province=' + searchInputs['province']
        : ''
    }`;
    search += `${
      searchInputs['gender'].length > 0
        ? '&gender=' + searchInputs['gender']
        : ''
    }`;

    navigate(`/event/${category}${search}`);
  };

  return loading ? (
    <Loading />
  ) : (
    <Master showSidebar={false} containerFullWidth={true} headerFixed={true}>
      <div className='image-cover'>
        <div className='home-back-img w-100 d-flex flex-column '>
          <div className='row shadow-sm border rounded-1 bg-white p-2 m-3 '>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
              <div className='form-group mx-1'>
                <input
                  defaultValue={searchInputs['title']}
                  type='text'
                  onChange={(e) => onChangeInput('title', e.target.value)}
                  className='form-control'
                  placeholder='عنوان'
                />
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
              <div className='form-group mx-1'>
                <select
                  defaultValue={searchInputs['province']}
                  className='form-control'
                  onChange={(e) => onChangeInput('province', e.target.value)}
                >
                  <option value=''>استان</option>
                  {eventContext.provinces.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
              <div className='form-group mx-1'>
                <select
                  className='form-control'
                  defaultValue={searchInputs['gender']}
                  onChange={(e) => onChangeInput('gender', e.target.value)}
                >
                  <option value=''>جنسیت</option>
                  <option value='1'>مرد</option>
                  <option value='2'>زن</option>
                  <option value='3'>هردو</option>
                </select>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
              <div className='form-group mx-1'>
                <button
                  className='btn btn-danger d-flex flex-row'
                  onClick={searchEvents}
                >
                  <i className='fad fa-search f-16 text-dark-mode mt-1'></i>
                  <span className='mx-2 '>جستجو</span>
                </button>
              </div>
            </div>
          </div>

          <div className='row mx-2'>
            {eventContext?.events?.data?.map((item) => (
              <div
                key={item.id}
                className='card-hover col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 my-2 p-0 px-1 overflow-hidden'
              >
                <div className='card  border rounded overflow-hidden position-relative'>
                  <div className='bg-purple card-bg w-100 p-3 d-flex flex-row justify-content-center'>
                    <span
                      className='text-dark-mode f-12 font-weight-bold'
                      style={{
                        height: '35px',
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                  <div className='card-bg w-100 d-flex flex-row justify-content-center'>
                    <img
                      style={{ height: '250px' }}
                      src={item?.thumbnail ?? Logo}
                      alt={item?.title}
                      className='w-100 img-thumbnail'
                    />
                  </div>
                  <div className='card-body p-0 d-flex flex-column justify-content-center w-100 align-items-center'>
                    <div className='d-flex flex-column p-2 justify-content-center w-100 align-items-center'>
                      {eventContext.event?.place !== undefined &&
                      eventContext.event?.place != null ? (
                        <span className='f-14 my-2'>مکان : {item.place}</span>
                      ) : null}

                      <span className='f-14 my-2'>زمان : {item.time}</span>
                      {item?.link?.length > 0 ? (
                        <a
                          className='text-danger align-self-end f-14 font-weight-bold my-2'
                          href={item?.link}
                          target='_blank'
                        >
                          ثبت نام در رویداد
                        </a>
                      ) : (
                        <Link
                          className='text-danger align-self-end f-14 font-weight-bold my-2'
                          to={`/event/show/${item.id}`}
                        >
                          مشاهده جزئیات رویداد
                        </Link>
                      )}
                    </div>

                    <div className='d-flex flex-row justify-content-center border w-100 p-2'>
                      <div className='d-flex flex-column border-left w-50 text-center'>
                        <span className=''>تاریخ شروع ثبت نام</span>
                        <span className='' dir='ltr'>
                          {moment(
                            item.start_register_date,
                            'YYYY-MM-DD HH:mm:ss',
                          )
                            .locale('fa')
                            .format('YYYY/MM/DD')}
                        </span>
                      </div>
                      <div className='d-flex flex-column w-50 text-center'>
                        <span className=''>تاریخ پایان ثبت نام</span>
                        <span className='' dir='ltr'>
                          {moment(item.end_register_date, 'YYYY-MM-DD HH:mm:ss')
                            .locale('fa')
                            .format('YYYY/MM/DD')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='overflow-hidden card-label'>
                  {moment()
                    .local('fa')
                    .isAfter(
                      moment(item?.end_register_date, 'YYYY-MM-DD HH:mm:ss'),
                    ) ? (
                    <>
                      <span className='bg-success text-dark-mode f-12 font-weight-bold'>
                        پایان ثبت نام
                      </span>
                    </>
                  ) : (
                    <>
                      {item.capacity != null &&
                      item.capacity <= item?.users?.length ? (
                        <span className='bg-danger text-dark-mode f-12 font-weight-bold'>
                          ظرفیت تکمیل
                        </span>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
            ))}
            {eventContext.event.meta?.pagination?.total_pages > 1 && (
              <div className='col-12 my-3'>
                <Pagination
                  totalPage={eventContext.events.meta?.pagination?.total_pages}
                  basePath={`/event/${category}`}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Master>
  );
};
export default Events;
